<template>
  <div class="collection-subject">
      <div class="top">
          <img v-if="top_url" :src="top_url" />
      </div>
      <div class="KV">
          <img v-if="banner_url" :src="banner_url" />
      </div>
      <div class="deadline">
          <img src="@/assets/images/collection/deadline_days.png" />
          <div class="days">
            <span>{{day_1}}</span><span>{{day_2}}</span><span>{{day_3}}</span>天
          </div>
      </div>
      <div class="main">
          <div>
        <van-button color="#B01C06" style="border-radius:5px;height:38px;" plain @click="goAdd()">添加课题</van-button>
        <span style="padding:10px;font-size:14px;color:#144A93;float:right;" v-if="updateDate">最近上报时间:{{updateDate}}</span>
          </div>
          <div class="invite" v-show="showInvite">
              <div style="padding:10px;">
                    <img src="@/assets/images/collection/invite_icon.png" style="vertical-align:text-bottom;"><span style="white-space:nowrap;font-size:16px;margin-left:3px;">输入邀请码,上报更多</span>
              </div>
            <div class="invite-input">
                <van-field placeholder="请输入邀请码" 
                v-model="inviteCode"
                style="margin:0 10px;width:calc(100% - 20px);border-radius:5px;font-size:16px;">
                </van-field>
                <img src="@/assets/images/collection/invite_success.png" class="right" v-if="checkInvite"/>
                <van-button color="#B01C06" plain 
                style="border:0;background:transparent;width:20%;height:24px;right:10px;top:50%;transform:translate(0,-50%)" 
                class="right" 
                @click="checkCode()"
                v-else

                >确定</van-button>
            </div>

          </div>
        <div class="one-piece" v-for="(item) in subjects" :key="item.id+item.title">
            <div class="operate">
                <img src="@/assets/images/collection/subject_icon.png" />
                <span>{{item.title}}</span>
                <div class="buttons">
                <img src="@/assets/images/collection/edit.png" style="margin-right:15px;" @click="goEdit(item)"/>
                <img src="@/assets/images/collection/delete.png" @click="goDelete(item)"/>
                </div>
            </div>
            <span v-if="item.f_tag&&item.s_tag" style="color:#B5B5B5;font-size:14px;margin-top:10px;">{{item.f_tag.name+'-'+item.s_tag.name}}</span>
            <span v-if="item.fup_tag&&item.sup_tag" style="color:#B5B5B5;font-size:14px;margin-top:10px;">,{{item.fup_tag.name+'-'+item.sup_tag.name}}</span>
            <div class="content" v-if="item.content"><p class="line-clamp-5">{{item.content}}</p></div>
            <div class="content" v-else><p class="line-clamp-5">{{item.title}}</p></div>
            <div class="date">
                <span style="color:#B5B5B5;font-size:14px;">{{getDate(item.updated_at)}}</span>
                <!-- <van-button style="float:right;">提交</van-button> -->
            </div>
        </div>
        <div class="add" v-for="i in to_do_count" :key="i" @click="goAdd()">
            <div class="add-icon">
                <img src="@/assets/images/collection/add.png" />
            </div>
        </div>
        
      </div>
      <div class="back" @click="goIndex()">
            <img src="@/assets/images/collection/back_index.png" />
      </div>
  </div>
</template>

<script>
import {PersoanalUserInfo,topics,inviteCode} from '../../config/interface.js'
import { Dialog } from "vant";
export default {
    data(){
        return{
            message:'',
            id:this.$route.query.id,
            days:0,
            day_1:0,
            day_2:0,
            day_3:0,
            updateDate:'',
            to_do_count:0,
            max_count:0,
            subjects:[],
            showInvite:false,
            checkInvite:0,
            inviteCode:'',
            top_url:'',
            banner_url:''

        }
    },
    created(){
        this.getUserInfo();
        document.title="CEC官方";
        if(common.is_weixin()){
			common.wxShare('课题申报@中国血管论坛CEC2023','上报课题截止时间：2023年9月30日，欢迎您填写您的课题，谢谢您。','cdn.edstatic.com/203012120000/b20d0c68aad9dc88de3d7708dbf6c374/2022/07/9a6c31a0-d2f1-490c-8aa0-5942dc78e9dc.png');
		}

    },
    methods:{
        //得到用户信息
        getUserInfo(){
            const url=PersoanalUserInfo;
            let params={};
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    localStorage.setItem('userInfo',JSON.stringify(data));
                    this.$store.dispatch('storageUserInfo',data);	
                    this.userInfo=data;
                    if(this.userInfo&&this.userInfo.mobile_status==1){
                        this.getSetting();
                    
                    }
                    else{
                        common.toast('未绑定手机',1000,'fail',()=>{
                                this.$router.replace({
                                path:'/collection/login',
                                query:{url:window.location.href}
                        })
                        })	
                    }
                }
            })
        },
        getSetting(){
            const url='webapi/meetings/'+this.id+'/collects';
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.top_url=data.top_img;
                    this.banner_url=data.banner;
                    if(res.data.end_at){
                        let arr=res.data.end_at.split('-');
                        let end_date=new Date(arr[0]+"/"+arr[1]+"/"+arr[2])
                        let now_date=new Date();
                        let difftime = (end_date - now_date)/1000; //计算时间差,并把毫秒转换成秒
	                    let days = parseInt(difftime/86400); // 天  24*60*60*1000 
                        this.day_1=parseInt(days/100);
                        this.day_2=parseInt(days%100/10);
                        this.day_3=parseInt(days%10);
                        this.days=days;
                    }
                    if(res.data.updated_at){
                        this.updateDate=this.transformDate(res.data.updated_at);
                    }
                    this.max_count=res.data.max_topic;
                    this.getSubjects();
                }
            })
        },
        getSubjects(){
            const url=topics;
            let params={
                id:this.id
            };
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                   this.subjects=res.data;
                   this.to_do_count=this.max_count-res.data.length;
                }
            })
        },
        checkCode(){
            if(this.inviteCode){
                const url=inviteCode+this.inviteCode;
                let params={};
                const method='GET';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.checkInvite=true;
                        common.toast('邀请码验证成功！',1000,'success',()=>{
                             this.$router.push({
                                path:'/collection/upload',
                                query:{
                                    meeting_id:this.id,
                                }
                        })
                                
                        })
                    }
                    else{
                        common.toast(res && res.error_msg ? res.error_msg : "未知错误",2000,'fail',()=>{
                            
                        })
                    }
                })
            }
            else{
                common.toast('请输入邀请码',1000,'fail',()=>{
                                
                })
            }

        },
        goIndex(){
            this.$router.push({
				path:'/collection/index',
                query:{
                    id:this.id
                }
			});
        },
        transformDate(str){
            if(str){
                str=str.split(" ")[0];
                let arr=str.split("-");
                return arr[0]+"年"+arr[1]+"月"+arr[2]+"日";
            }
            return "";
        },
        getDate(str){
            if(str){
                str=str.split(" ")[0];
                return str;
            }
            return "";

        },
        goEdit(item){
            this.$router.push({
                path:'/collection/upload',
                query:{
                    meeting_id:this.id,
                    id:item.id
                }
            })

        },
        goAdd(){
            if(this.to_do_count>0){
                this.$router.push({
                    path:'/collection/upload',
                    query:{
                        meeting_id:this.id,
                    }
                })
            }
            else{
                this.showInvite=true;
            }

        },
        goDelete(item){
            Dialog.confirm({
                message: "确定删除课题——"+item.title+"？",
            })
          .then(() => {
              const url=topics+"/"+item.id;
                let params={};
                const method='DELETE';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.getSubjects();
                    }
                })
          })
        }

    }

}
</script>

<style lang="scss">
.collection-subject{
    margin-bottom: 30px;
    .top{
        img{
            width: 100%;
        }
    }
    .KV{
        margin: 15px;
        img{
            width: 100%;
            border-radius: 10px;
        }
    }
    .deadline{
        width: 40%;
        margin-left: 50%;
        margin-top: -60px;
        background: white;
        transform: rotateZ(360deg);
        padding: 0 10px 10px;
        border-radius: 5px;
        font-size: 16px;
        img{
            width: 100%;
        }
        .days{
            display: flex;
            flex: 1;
            flex-wrap: nowrap;
            justify-content: space-around;
        }
        span{
            border-radius: 4px;
            font-size: 16px;
            padding: 0 5px;
            background: linear-gradient(0deg, #ffffff 0.05%, #6892c6 100%);
        }
        

        
    }
    .main{
        margin: 0 15px 15px;
        .invite{
            margin-top: 15px;
            background-color: #f9e2df;
            border-radius: 5px;
            padding-bottom: 20px;
            img{
                width: 15px;
            }
            .invite-input{
                position: relative;
                .right{
                    position: absolute;
                    right: 15px;
                    top: 10px;
                    width: 20px;
                }
            }
        }
        .one-piece{
            padding: 15px;
            margin-top: 15px;
            font-size: 16px;
            background: white;
            border-radius: 10px;
            img{
                width: 18px;
                vertical-align: text-bottom;
            }
            .van-button{
                background-color:#B01C06;
                color:white;
                border-radius:10px;
                height: 30px;
            }
            .buttons{
                display: inline;
                float: right;
            }
            .content{
                background: #F7F7F7;
                padding: 10px;
                margin: 5px 0 10px;
                border-radius: 10px;
            }
        }
        .add{
            background: white;
            margin-top: 15px;
            padding: 20px 0;
            border-radius: 10px;
            text-align: center;
            .add-icon{
                margin: 0 20px;
                border: 1px dashed #8a8a8a;
                height: 160px;
                line-height: 160px;
                img{
                    height: 80px;
                    vertical-align: middle;
                }

            }
        }
        .line-clamp-5{ overflow:hidden;-ms-text-overflow:ellipsis;text-overflow:ellipsis; display:-webkit-box; -webkit-box-orient:vertical; -webkit-line-clamp:5;}
        
    }
    .back{
        position: fixed;
        right: 0;
        bottom: 30px;
        img{
            height: 40px;
        }
    }
}
.van-dialog__confirm{
    color: #B01C06;
}
</style>


// WEBPACK FOOTER //
// src/pages/Contributions/subject.vue